var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.71429V14.2857C16 15.2321 15.2321 16 14.2857 16H11.2393V9.67143H13.4036L13.7143 7.25714H11.2393V5.71429C11.2393 5.01429 11.4321 4.53929 12.4357 4.53929H13.7143V2.38214C13.4929 2.35357 12.7357 2.28571 11.85 2.28571C10.0071 2.28571 8.74286 3.41071 8.74286 5.47857V7.26071H6.57143V9.675H8.74643V16H1.71429C0.767857 16 0 15.2321 0 14.2857V1.71429C0 0.767857 0.767857 0 1.71429 0H14.2857C15.2321 0 16 0.767857 16 1.71429Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.7e69bcba6f84cdd625d4ae5506ff6a9f.svg";
export { ForwardRef as ReactComponent };